import {
  useFormatAmount,
  type FormatAmountCurrency,
} from "@/hooks/useFormatAmount";
import i18n from "@/i18n/config";

interface ExchangeRateProps {
  unit: number;
  currency: FormatAmountCurrency;
  exchangeRate: number;
  exchangeCurrency: FormatAmountCurrency;
  locale?: Intl.UnicodeBCP47LocaleIdentifier;
  trailingColor?: string;
}

export const ExchangeRate = ({
  unit,
  currency,
  exchangeRate,
  exchangeCurrency,
  locale = i18n.language,
  trailingColor = "gray",
}: ExchangeRateProps) => {
  const { formatExchangeRate } = useFormatAmount();
  const { unit: formattedUnit, rate } = formatExchangeRate(
    unit,
    currency,
    exchangeRate,
    exchangeCurrency,
    locale
  );

  return (
    <span>
      {formattedUnit}
      {" = "}
      {rate.significant}
      <span style={{ color: trailingColor }}>{rate.trailing}</span>
    </span>
  );
};
